import React from "react";
import Text from "../typography/Text";

interface IErrorMessageProps {
  text: string;
  visible?: boolean;
}

export default function ErrorMessage({ text, visible = false }: IErrorMessageProps) {
  if (!visible) {
    return null;
  }

  return (
    <Text mt={3} mb={0} color="red.600" fontSize="sm">
      {text}
    </Text>
  );
}
